export function dateFormat(string) {
  const date = new Date(string).toLocaleString('ru', { day: 'numeric', month: 'long', year: 'numeric' });

  if (date !== 'Invalid Date') {
    return date;
  }

  return '';
}
